import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function CurtainIntro() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const played = sessionStorage.getItem('lbh_curtain_played');
    if (!played) {
      setShow(true);
      sessionStorage.setItem('lbh_curtain_played', '1');
      document.body.style.overflow = 'hidden';
    }
  }, []);
  useEffect(() => {
    if (!show) {
      document.body.style.overflow = '';
    }
  }, [show]);
  // Total visible time before unmount
  const totalDuration = 3.2;
  return <AnimatePresence data-id="element-96">
      {show && <motion.div className="fixed inset-0 z-[100]" initial={{
      opacity: 1
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0,
      y: '-100%'
    }} transition={{
      duration: 0.9,
      ease: [0.76, 0, 0.24, 1]
    }} onAnimationComplete={() => {
      window.setTimeout(() => setShow(false), totalDuration * 1000);
    }} aria-hidden="true" style={{
      // Warm parchment / cream
      background: 'radial-gradient(ellipse at center, #fbf3e3 0%, #f5e9cf 55%, #ecdcb6 100%)'
    }} data-id="element-97">
          {/* Subtle paper grain texture */}
          <div className="absolute inset-0 opacity-[0.18] mix-blend-multiply pointer-events-none" style={{
        backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='220' height='220'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.42 0 0 0 0 0.32 0 0 0 0 0.18 0 0 0 0.55 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
      }} data-id="element-98" />

          {/* Soft golden vignette glow at corners */}
          <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(circle at 10% 0%, rgba(212,175,107,0.25), transparent 40%), radial-gradient(circle at 90% 100%, rgba(212,175,107,0.25), transparent 40%)'
      }} data-id="element-99" />

          {/* Animated gold frame */}
          <div className="absolute inset-0 flex items-center justify-center p-6 sm:p-10" data-id="element-100">
            <div className="relative w-full h-full max-w-3xl max-h-[80vh]" data-id="element-101">
              {/* Top line */}
              <motion.div initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            delay: 0.1,
            duration: 0.7,
            ease: 'easeOut'
          }} style={{
            transformOrigin: 'left center',
            background: 'linear-gradient(90deg, transparent, #d4af6b 15%, #f5d99a 50%, #d4af6b 85%, transparent)',
            boxShadow: '0 0 8px rgba(212,175,107,0.5)'
          }} className="absolute top-0 left-0 right-0 h-[1.5px]" data-id="element-102" />
              {/* Right line */}
              <motion.div initial={{
            scaleY: 0
          }} animate={{
            scaleY: 1
          }} transition={{
            delay: 0.7,
            duration: 0.6,
            ease: 'easeOut'
          }} style={{
            transformOrigin: 'top center',
            background: 'linear-gradient(180deg, transparent, #d4af6b 15%, #f5d99a 50%, #d4af6b 85%, transparent)',
            boxShadow: '0 0 8px rgba(212,175,107,0.5)'
          }} className="absolute top-0 right-0 bottom-0 w-[1.5px]" data-id="element-103" />
              {/* Bottom line */}
              <motion.div initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            delay: 1.2,
            duration: 0.7,
            ease: 'easeOut'
          }} style={{
            transformOrigin: 'right center',
            background: 'linear-gradient(90deg, transparent, #d4af6b 15%, #f5d99a 50%, #d4af6b 85%, transparent)',
            boxShadow: '0 0 8px rgba(212,175,107,0.5)'
          }} className="absolute bottom-0 left-0 right-0 h-[1.5px]" data-id="element-104" />
              {/* Left line */}
              <motion.div initial={{
            scaleY: 0
          }} animate={{
            scaleY: 1
          }} transition={{
            delay: 1.8,
            duration: 0.6,
            ease: 'easeOut'
          }} style={{
            transformOrigin: 'bottom center',
            background: 'linear-gradient(180deg, transparent, #d4af6b 15%, #f5d99a 50%, #d4af6b 85%, transparent)',
            boxShadow: '0 0 8px rgba(212,175,107,0.5)'
          }} className="absolute top-0 left-0 bottom-0 w-[1.5px]" data-id="element-105" />

              {/* Corner ornaments */}
              {['top-2 left-2', 'top-2 right-2 rotate-90', 'bottom-2 right-2 rotate-180', 'bottom-2 left-2 -rotate-90'].map((pos, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.6
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 2.2 + i * 0.08,
            duration: 0.4
          }} className={`absolute ${pos} w-8 h-8 sm:w-10 sm:h-10`} data-id="element-106">
                  <svg viewBox="0 0 40 40" className="w-full h-full" data-id="element-107">
                    <path d="M2 2 L2 14 M2 2 L14 2 M2 8 Q8 8 8 2" fill="none" stroke="#d4af6b" strokeWidth="1.2" strokeLinecap="round" data-id="element-108" />
                  </svg>
                </motion.div>)}
            </div>
          </div>

          {/* Center logo + glow */}
          <div className="absolute inset-0 flex flex-col items-center justify-center px-6" style={{
        isolation: 'isolate'
      }} data-id="element-109">
            {/* Pulsing golden glow halo BEHIND logo */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.4
        }} animate={{
          opacity: [0, 0.9, 0.7, 0.9],
          scale: [0.4, 1, 0.95, 1.05]
        }} transition={{
          delay: 0.2,
          duration: 2.4,
          times: [0, 0.4, 0.7, 1],
          ease: 'easeOut'
        }} className="absolute" style={{
          width: 'min(420px, 70vw)',
          height: 'min(420px, 70vw)',
          background: 'radial-gradient(circle, rgba(245,217,154,0.55) 0%, rgba(212,175,107,0.25) 35%, transparent 65%)',
          filter: 'blur(20px)'
        }} data-id="element-110" />

            {/* Logo — uses mix-blend-mode: darken so the white background of
                the logo PNG is replaced by the cream parchment (darken keeps
                the darker color per pixel: cream beats pure white, but gold
                and black stay intact). */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.85,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative" style={{
          maxWidth: 'min(78vw, 28rem)',
          maxHeight: 'min(360px, 55vh)'
        }} data-id="element-111">
              <motion.img src="https://cdn.magicpatterns.com/uploads/sYLXwGLxwWhhKoQY9TL7EJ/LORE1X1%2C2.png" alt="Lorena Beauty House" className="block w-full h-auto object-contain" style={{
            mixBlendMode: 'darken',
            maxHeight: 'min(360px, 55vh)',
            // Feather the edges with a radial mask so the rectangular
            // white PNG background dissolves smoothly into the parchment
            // instead of showing a hard rectangle.
            WebkitMaskImage: 'radial-gradient(ellipse 60% 60% at 50% 50%, black 45%, rgba(0,0,0,0.85) 60%, transparent 85%)',
            maskImage: 'radial-gradient(ellipse 60% 60% at 50% 50%, black 45%, rgba(0,0,0,0.85) 60%, transparent 85%)',
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat'
          }} animate={{
            filter: ['contrast(1.05) drop-shadow(0 0 0px rgba(245,217,154,0))', 'contrast(1.05) drop-shadow(0 0 24px rgba(245,217,154,0.85)) drop-shadow(0 0 48px rgba(212,175,107,0.5))', 'contrast(1.05) drop-shadow(0 0 18px rgba(245,217,154,0.6)) drop-shadow(0 0 36px rgba(212,175,107,0.35))', 'contrast(1.05) drop-shadow(0 0 28px rgba(245,217,154,0.9)) drop-shadow(0 0 56px rgba(212,175,107,0.55))']
          }} transition={{
            delay: 0.6,
            duration: 2.4,
            times: [0, 0.35, 0.7, 1],
            ease: 'easeInOut'
          }} data-id="element-112" />
            </motion.div>

            {/* Shimmer sweep — placed OUTSIDE the logo blend container so it
                doesn't interfere with the white-removal blend mode. */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: [0, 1, 0]
        }} transition={{
          delay: 1.6,
          duration: 1.2
        }} className="absolute pointer-events-none overflow-hidden" style={{
          width: 'min(78vw, 28rem)',
          height: 'min(360px, 55vh)',
          mixBlendMode: 'screen'
        }} data-id="element-113">
              <motion.div initial={{
            x: '-120%'
          }} animate={{
            x: '120%'
          }} transition={{
            delay: 1.6,
            duration: 1.2,
            ease: 'easeInOut'
          }} className="absolute inset-0" style={{
            background: 'linear-gradient(105deg, transparent 35%, rgba(255,240,200,0.55) 50%, transparent 65%)'
          }} data-id="element-114" />
            </motion.div>

            {/* Tagline */}
            <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1.4,
          duration: 0.7
        }} className="mt-4 flex items-center gap-3" data-id="element-115">
              <span className="h-px w-8" style={{
            background: 'linear-gradient(90deg, transparent, #b8924a)'
          }} data-id="element-116" />
              <p className="text-[#7a5a25] tracking-[0.45em] text-[10px] sm:text-xs uppercase font-light" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-117">
                Queens · New York
              </p>
              <span className="h-px w-8" style={{
            background: 'linear-gradient(90deg, #b8924a, transparent)'
          }} data-id="element-118" />
            </motion.div>
          </div>

          {/* Floating gold particles for sparkle */}
          {[...Array(12)].map((_, i) => {
        const left = i * 83 % 100;
        const top = i * 47 % 100;
        const delay = 0.5 + i % 6 * 0.18;
        return <motion.div key={i} initial={{
          opacity: 0,
          scale: 0
        }} animate={{
          opacity: [0, 1, 0.4, 1, 0],
          scale: [0, 1, 0.8, 1, 0],
          y: [0, -20, -40]
        }} transition={{
          delay,
          duration: 2.6,
          ease: 'easeOut'
        }} className="absolute w-1 h-1 rounded-full pointer-events-none" style={{
          left: `${left}%`,
          top: `${top}%`,
          background: '#f5d99a',
          boxShadow: '0 0 6px #f5d99a, 0 0 12px rgba(212,175,107,0.7)'
        }} data-id="element-119" />;
      })}
        </motion.div>}
    </AnimatePresence>;
}